import React, { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "../header/Header";
import SideBar from "../SideBar/SideBar";

const MainLayout = () => {
  const { pathname } = useLocation();
  const showSidebar = !pathname.includes("quiz") || pathname.includes("review");
  const mainRef = useRef<HTMLElement>(null);

  useEffect(() => {
    if (mainRef.current) {
      mainRef.current.scrollTo({ top: 0, behavior: "auto" });
    }
  }, [pathname]);

  return (
    <div className="flex h-screen w-full flex-col bg-slate-50 overflow-hidden">
      {showSidebar && <Header />}

      <div className="flex flex-1 overflow-hidden relative">
        {showSidebar && <SideBar />}

        <main ref={mainRef} className={`flex-1 overflow-y-auto overflow-x-hidden ${showSidebar ? "p-6" : ""}`}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
